// Library Imports
import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import * as MdIcons from 'react-icons/md'
import * as BsIcons from 'react-icons/bs'
// Component Imports
import PageBanner from '../../components/banner/PageBanner'
import ContactCard from '../../components/card/ContactCard'
import ContactForm from '../../components/form/ContactForm'

function Contact() {
  return (
    <div className='contactpage'>
      <PageBanner pageName="Contact Us" />
      <Container className='my-5'>
        <Row>
          <Col xs={12} sm={12} md={4} lg={4} xl={4}>
            <ContactCard
              header='Address'
              textLine1='6486 East Main Street Reynoldsburg,'
              textLine2='Ohio 43068'
              icon={<MdIcons.MdOutlineShareLocation />} />
          </Col>
          <Col xs={12} sm={12} md={4} lg={4} xl={4}>
            <ContactCard
              header='Phone'
              textLine1='Telephone: (614)-861-3636'
              textLine2='Fax: (614)-861-8040'
              icon={<BsIcons.BsPhoneVibrate />} />
          </Col>
          <Col xs={12} sm={12} md={4} lg={4} xl={4}>
            <ContactCard
              header='Email'
              textLine1='usjersey@usjersey.com'
              textLine2='infojersey@usjersey.com'
              icon={<MdIcons.MdOutlineMailOutline />} />
          </Col>
        </Row>
        <Row>
          <Col xs={12} sm={12} md={12} lg={6} xl={6} className='slide-in-fwd-bottom'>
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3058.3045619542086!2d-82.82606688468228!3d39.95694287942139!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8838637cfea2dff7%3A0x3f9170cc7d3c6605!2s6486%20E%20Main%20St%2C%20Reynoldsburg%2C%20OH%2043068!5e0!3m2!1sen!2sus!4v1672238292358!5m2!1sen!2sus"
              width="100%"
              height="520"
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"></iframe>
          </Col>
          <Col xs={12} sm={12} md={12} lg={6} xl={6} className='slide-in-fwd-bottom'>
            <ContactForm />
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default Contact